module.exports = __webpack_public_path__ + "static/media/directMessage.06fbc401.svg";